import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { NavLink } from 'react-router-dom'

class ButtonSecondary extends React.Component {
  renderClick(e) {
    e.preventDefault();

    this.props.onClick();
  }

  render() {
    return (
      <NavLink className={classnames('btn-secondary', this.props.className)} to={ this.props.to }>{this.props.children}</NavLink>
    )
  }
}

ButtonSecondary.propTypes = {
  to: PropTypes.string
}

export default ButtonSecondary;



// WEBPACK FOOTER //
// ./src/components/buttons/secondary/index.js